export const GET_CLIENTS_FOR_ANNUAL_RETURN = "GET_CLIENTS_FOR_ANNUAL_RETURN"
export const GET_ANNUAL_RETURN_CLIENT = "GET_ANNUAL_RETURN_CLIENT"
export const UPDATE_CLIENT_FOR_ANNUAL_RETURN = "UPDATE_CLIENT_FOR_ANNUAL_RETURN"
export const ADD_CLIENT_TO_ANNUAL_RETURN = "ADD_CLIENT_TO_ANNUAL_RETURN"
export const CLEAR_ANNUAL_RETURN_CLIENT = "CLEAR_ANNUAL_RETURN_CLIENT"
export const GET_EMPLOYEES_FOR_ANNUAL_RETURN = "GET_EMPLOYEES_FOR_ANNUAL_RETURN"


// WEBPACK FOOTER //
// ./src/actionTypes/annualReturnClient.js